import type { PropsWithChildren, ReactNode } from "react";

import type { FlashpayRole } from "./roles";
import { useRealmRoles } from "./roles";

/**
 * Garde d'affichage par rôle : rend `children` seulement si l'utilisateur
 * a au moins un des rôles exigés ; sinon `fallback` (null par défaut =
 * masquage pur).
 */
export function RequireRole({
  roles,
  fallback = null,
  children,
}: PropsWithChildren<{
  roles: readonly (FlashpayRole | string)[];
  fallback?: ReactNode;
}>) {
  const realmRoles = useRealmRoles();
  const allowed = roles.some((role) => realmRoles.includes(role));
  return allowed ? <>{children}</> : <>{fallback}</>;
}
